module.exports = {"TXTCLI_LoadingXX_Please_wait":{"id":"TXTCLI_LoadingXX_Please_wait","defaultMessage":"În curs de încărcare... Te rugăm să aştepţi"}}